import { joinPath } from '@eventbrite/path-utils';
import {
    BASE_URL,
    CHECKOUT_PATH,
    DELIVERY_METHODS_PATH,
} from '../../../constants';
import { getAttendees } from '../../../selectors/order';
import { shouldShowDeliveryMethodPage } from './shouldShowDeliveryMethodPage';
import { push } from 'react-router-redux';

const getPathAfterReservedSeating = (state) => {
    const attendees = getAttendees(state);

    return shouldShowDeliveryMethodPage(attendees)
        ? DELIVERY_METHODS_PATH
        : CHECKOUT_PATH;
};

export const goToPageAfterReservedSeating = () => (dispatch, getState) => {
    const path = getPathAfterReservedSeating(getState());

    return dispatch(push(joinPath(BASE_URL, path)));
};
